import { MouseEvent, useState } from 'react';
import axios from 'axios';

import { DashbaordMyBizItem, DashbaordPagination, getMybizDashboard } from '@/api/pc-api/v1/mybiz/list/dashboard';
import Pagination from '@/components/common/Pagination';
import DataLoading from '@/components/Loading/DataLoading';
import { isBadgedPartnerRegStatus } from '@/constants/partnerRegStatus';
import { AUTH_INFO_ID, ROUTES } from '@/constants/routes';
import { useAbortController } from '@/hooks/useAbortController';
import useDidMountEffect from '@/hooks/useDidMountEffect';
import usePrefixNavigate from '@/hooks/usePrefixNavigate';
import { DashboardQuery } from '@/pages/root';
import MyBizItem from '@/pages/root/components/MyBizItem';
import MyBizListEmpty from '@/pages/root/components/MyBizListEmpty';
import { replacePathParams } from '@/utils/route';

type Props = {
  initialMyBizData: DashbaordPagination;
  query: DashboardQuery;
  updatePage: (page: number) => void;
};

const MyBizSearchResult = ({ initialMyBizData, query, updatePage }: Props) => {
  const { navigate } = usePrefixNavigate();
  const { controller } = useAbortController();
  const [myBizList, setMyBizList] = useState<DashbaordPagination>(initialMyBizData);
  const isMyBizList = !!myBizList.data.length;
  const [isLoading, setIsLoading] = useState(false);

  const onClickMyBiz = (e: MouseEvent<HTMLAnchorElement>, myBiz: DashbaordMyBizItem) => {
    e.preventDefault();
    if (isBadgedPartnerRegStatus(myBiz.partnerRegStatus)) return;

    navigate(replacePathParams(ROUTES.DASHBOARD, { [AUTH_INFO_ID]: myBiz.authInfoId }));
  };

  const onClickRegisterApp = (e: MouseEvent<HTMLButtonElement>, myBiz: DashbaordMyBizItem) => {
    e.preventDefault();
    e.stopPropagation();

    navigate(replacePathParams(ROUTES.APP.REGISTER, { [AUTH_INFO_ID]: myBiz.authInfoId }));
  };

  const fetchMyBizList = async (query: string, page: number) => {
    controller.abort();

    try {
      setIsLoading(true);
      const { data } = await getMybizDashboard({
        companyName: query,
        page,
        options: { signal: controller.getSignal() }
      });
      setMyBizList(data);
      updatePage(data.page);
      setIsLoading(false);
    } catch (e) {
      if (axios.isCancel(e)) return;
      setIsLoading(false);

      throw e;
    }
  };

  const onClickPage = (newPage: number) => {
    updatePage(newPage);
  };

  const renderComponent = () => {
    if (isMyBizList) {
      return (
        <ul className="list_mybiz">
          {myBizList.data.map((data, i) => (
            <MyBizItem key={i} data={data} onClickMyBiz={onClickMyBiz} onClickRegisterApp={onClickRegisterApp} />
          ))}
        </ul>
      );
    }

    return <MyBizListEmpty title="검색결과가 없습니다." />;
  };

  useDidMountEffect(() => {
    fetchMyBizList(query.companyName, query.page);
  }, [query.companyName, query.page]);
  return (
    <>
      <div className="wrap_list_mybiz">
        {renderComponent()}
        {isLoading && <DataLoading />}
      </div>
      <Pagination currentPage={query.page} totalPage={myBizList.totalPageNumber} onClickPage={onClickPage} />
    </>
  );
};

export default MyBizSearchResult;
